import { Endpoints } from '@/core/models/endpoints.interface';

export interface LanguageEndpoints extends Pick<Endpoints, 'GET_ALL'> {}

export const LANGUAGE_ENDPOINTS: LanguageEndpoints = {
   GET_ALL: () => '/languages?filter[is_communication_language]=true',
};
